import { useTranslation } from 'react-i18next';
import styles from './PrivacyPolicy.module.css';
import { Link } from 'react-router-dom';
import PrivacyPolicyCard from '@/components/PrivacyPolicyCard';
import FadeInSection from '@/components/UI/FadeInSection';
import { useViewportHeight } from '@/hooks/useViewportHeight';

const PrivacyPolicy = () => {
	const { t } = useTranslation();
	useViewportHeight();

	return (
		<div className={styles.main_container}>
			<div className={styles.privacy_container}>
				<FadeInSection className={styles.privacy_box}>
					<PrivacyPolicyCard displayLogo={true} />

					<Link to="/signup" className={styles.navLink}>
						<p className={styles.forgotPass_label}>{t('privacyPolicy.signIn')}</p>
					</Link>
				</FadeInSection>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
